<script setup lang="ts">
import IconClose from 'assets/icons/close.svg';

export type TButtonSize = 'normal' | 'small' | 'big';

withDefaults(
  defineProps<{ disabled?: boolean; size?: TButtonSize; ariaLabel?: string }>(),
  {
    ariaLabel: 'close button',
    disabled: false,
    size: 'normal',
  },
);

const styleClasses = {
  normal: 'text-gray-800/50 cursor-pointer select-none text-center outline-none',
  hover: 'hover:text-gray-900',
  active: 'active:translate-y-[1px]',
  disabled: 'disabled:pointer-events-none disabled:text-gray-500/50',
};

const typedStyles = computed(
  () =>
    `${styleClasses.normal} `
    + `${styleClasses.hover} `
    + `${styleClasses.active} `
    + `${styleClasses.disabled} `,
);
</script>

<template>
  <button
    :aria-label="ariaLabel"
    :disabled="disabled"
    :class="typedStyles"
  >
    <IconClose
      :class="{
        'w-4 h-4': size === 'small',
        'w-6 h-6': size === 'normal',
        'w-8 h-8': size === 'big',
      }"
    />
  </button>
</template>

<style scoped lang="scss"></style>
